<template>
    <y-upload-image
        v-if="propsObj._kind === 'uploadImage'"
        :propsObj="propsObj"
        :value="value"
        ossType="putUpload"
        @change="change"
    ></y-upload-image>

    <div
        v-else
        :class="[
            prefixCls,
            'ZUpload',
            `ZUpload-${showType}`,
            { 'ZUpload-readonly': $isReadonly(canEdit, propsObj) },
            { 'ZUpload-disabled': $isDisabled(canEdit, propsObj) }
        ]"
    >
        <!-- 上传 -->
        <div
            v-if="finalCanEdit"
            :class="classes"
            @click="handleClick"
            @drop.prevent="onDrop"
            @paste="handlePaste"
            @dragover.prevent="dragOver = true"
            @dragleave.prevent="dragOver = false"
        >
            <input
                ref="input"
                type="file"
                :class="[prefixCls + '-input']"
                @change="handleChange"
                :multiple="multiple"
                :webkitdirectory="webkitdirectory"
                :accept="accept"
            >
            <slot>
                <div :class="`ZUpload-${showType}-imageadd`">
                    <Icon
                        v-if="['new', 'inline'].includes(showType)"
                        custom="bico-font bico-upload1"
                    />
                    <span>上传</span>
                </div>
            </slot>
        </div>
        <!-- 列表 -->
        <slot name="list">
            <upload-list
                v-if="showUploadList"
                :propsObj="propsObj"
                :showType="showType"
                :files="val"
                :isReadonly="$isReadonly(canEdit, propsObj)"
                :isDisabled="$isDisabled(canEdit, propsObj)"
                :finalCanEdit="finalCanEdit"
                @on-file-remove="handleRemove"
                @on-file-preview="handlePreview"
            ></upload-list>
        </slot>
    </div>
</template>
<script>
    import YUploadImage from "./YUploadImage.vue";
    import uploadList from "./upload-list.vue";
    import controlMixin from "../../controlMixin.js";
    import uploadMixin from "./uploadMixin.js";

    import { getMsgText } from "../../../../https";

    const prefixCls = "ivu-upload";

    export default {
        name: "Upload",
        mixins: [controlMixin, uploadMixin],
        components: {
            YUploadImage,
            uploadList
        },
        props: {
            showUploadList: {
                type: Boolean,
                default: true
            },
            type: {
                type: String,
                default: "drag"
            },
            format: {
                type: Array,
                default () {
                    return [];
                }
            },
            maxSize: {
                type: Number
            },
            beforeUpload: Function,
            onProgress: {
                type: Function,
                default () {
                    return {};
                }
            },
            onSuccess: {
                type: Function,
                default () {
                    return {};
                }
            },
            onError: {
                type: Function,
                default () {
                    return {};
                }
            },
            onRemove: {
                type: Function,
                default () {
                    return {};
                }
            },
            onPreview: {
                type: Function,
                default () {
                    return {};
                }
            },
            onExceededSize: {
                type: Function,
                default () {
                    return {};
                }
            },
            onFormatError: {
                type: Function,
                default () {
                    return {};
                }
            },
            paste: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            webkitdirectory: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                prefixCls: prefixCls,
                dragOver: false,
                tempIndex: 1
            };
        },
        computed: {
            val: {
                get () {
                    return this.value[this.propsObj._key] || [];
                },
                set (val) {
                    this.value[this.propsObj._key] = val;
                }
            },
            itemDisabled () {
                return !this.finalCanEdit;
            },
            showType () {
                // 宽度不为100%,级联表格或内部表格中显示新版
                return this.propsObj.showType || ((this.propsObj._span < 24 && this.propsObj._span > 0 || this.propsObj.inTable) ? "new" : "old");
            },
            multiple () {
                return this.propsObj._multiple !== false;
            },
            accept () {
                let documentType = ["txt", "doc", "xls", "ppt", "docx", "xlsx", "pptx", "pdf"];
                let imageType = ["jpg", "png", "gif", "jpeg", "tiff", "swf"];
                let videoType = ["flv", "rmvb", "mp4", "mvb"];
                let audioType = ["wma", "mp3", "m4a"];
                let packageType = ["rar", "zip"];

                // 限制文件格式
                let format = [];
                if (this.propsObj._fileType === "image") {
                    format = imageType;
                } else {
                    format = [...documentType, ...imageType, ...videoType, ...audioType, ...packageType];
                }
                format = format.map(item => {
                    return `.${item}`;
                });
                return format.join();
            },
            classes () {
                return [
                    `${prefixCls}`,
                    {
                        [`${prefixCls}-select`]: this.type === "select",
                        [`${prefixCls}-drag`]: this.type === "drag",
                        [`${prefixCls}-dragOver`]: this.type === "drag" && this.dragOver,
                        [`ZUpload-${this.showType}-wrapper`]: true
                    }
                ];
            }

        },
        methods: {
            handleClick () {
                if (this.itemDisabled) return;
                this.$refs.input.click();
            },
            handleChange (e) {
                const files = e.target.files;

                if (!files) {
                    return;
                }
                this.uploadFiles(files);
                this.$refs.input.value = null;
            },
            onDrop (e) {
                this.dragOver = false;
                if (this.itemDisabled) return;
                this.uploadFiles(e.dataTransfer.files);
            },
            handlePaste (e) {
                if (this.itemDisabled) return;
                if (this.paste) {
                    this.uploadFiles(e.clipboardData.files);
                }
            },
            uploadFiles (files) {
                let postFiles = Array.prototype.slice.call(files);
                if (!this.multiple) postFiles = postFiles.slice(0, 1);

                if (postFiles.length === 0) return;
                postFiles.forEach(file => {
                    this.upload(file);
                });
            },
            upload (file) {
                if (!this.beforeUpload) {
                    return this.post(file);
                }

                const before = this.beforeUpload(file);
                if (before && before.then) {
                    before.then(processedFile => {
                        if (Object.prototype.toString.call(processedFile) === "[object File]") {
                            this.post(processedFile);
                        } else {
                            this.post(file);
                        }
                    }, () => {
                    });
                } else if (before !== false) {
                    this.post(file);
                } else {
                }
            },
            post (file) {
                // check format
                if (this.format.length) {
                    const fileFormat = file.name.split(".").pop().toLocaleLowerCase();
                    const checked = this.format.some(item => item.toLocaleLowerCase() === fileFormat);
                    if (!checked) {
                        this.onFormatError(file, this.value[this.propsObj._key]);
                        return false;
                    }
                }

                // check maxSize
                if (this.maxSize) {
                    if (file.size > this.maxSize * 1024) {
                        this.onExceededSize(file, this.value[this.propsObj._key]);
                        return false;
                    }
                }

                // 上传接口
                this.handlePost(file);
            },
            getFile (file) {
                const fileList = this.value[this.propsObj._key];
                let target;
                fileList.every(item => {
                    target = file.uid === item.uid ? item : null;
                    return !target;
                });
                return target;
            },
            handleProgress (percentage, file) {
                this.onProgress(percentage, file, this.value[this.propsObj._key]);
            },
            handleSuccess (res, data, file) {
                if (data.res === 0) {

                    if (!this.value[this.propsObj._key]) {
                        this.$set(this.value, this.propsObj._key, []);
                    }
                    this.value[this.propsObj._key].push(data.data);
                    this.onSuccess(res, file, this.value[this.propsObj._key]);

                    this.change();

                } else {
                    this.$Message.error({
                        content: `操作失败！${getMsgText(data.msg)}`,
                        duration: 4
                    });
                    this.handleError && this.handleError(res, data, file);
                }
            },
            handleError (err, response, file) {
                this.onError(err, response, file);
            },
            handleRemove (file) {
                const fileList = this.value[this.propsObj._key];
                fileList.splice(fileList.indexOf(file), 1);
                this.onRemove(file, fileList);
                this.change();
            },
            handlePreview (file) {
                if (file.status === "finished") {
                    this.onPreview(file);
                }
            },
            clearFiles () {
                this.value[this.propsObj._key] = [];
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/ZUpload/index.vue